/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { QboSettingsModelDto } from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class QbosettingsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags QboSettings
   * @name QboSettingsGet
   * @summary Gets QBO settings
   * @request GET:/qbosettings
   */
  qboSettingsGet = (params: RequestParams = {}) =>
    this.http.request<QboSettingsModelDto, any>({
      path: `/qbosettings`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags QboSettings
   * @name QboSettingsPost
   * @summary Posts QBO settings.
   * @request POST:/qbosettings
   */
  qboSettingsPost = (data: QboSettingsModelDto, params: RequestParams = {}) =>
    this.http.request<boolean, any>({
      path: `/qbosettings`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
